<section id="range-date-picker">
    <div class="row">
        <div class="col-12">
            <div class="card">
                <div class="card-header">
                    <h4 class="card-title">{{ title }}</h4>
                </div>
                <div class="card-content">
                    <div class="card-body">
                        <div class="d-flex flex-wrap flex-sm-nowrap">
                            <div class="col-md-6 d-flex flex-column align-items-center">
                                <fieldset class="form-group d-flex flex-column">
                                    <span>Desde</span>

                                    <div class="d-flex">
                                        <div class="d-flex flex-row-reverse align-items-center">
                                            <input class="form-control input-date-picker" placeholder="dd-mm-aaaa"
                                                name="df" [(ngModel)]="fromDate" (ngModelChange)="onChange()"
                                                ngbDatepicker [minDate]="minDate" [maxDate]="toDate ?? maxDate"
                                                [markDisabled]="isDisabled" #df="ngbDatepicker">
                                            <button *ngIf="fromDate" type="button" class="clear-btn"
                                                (click)="clearInput('fromDate')" aria-label="Limpiar" container="body"
                                                data-toggle="tooltip" placement="top" ngbTooltip="Limpiar selección">
                                                &times;
                                            </button>
                                        </div>
                                        <div class="input-group-append input-date-picker-calendar">
                                            <div class="input-group-text" (click)="df.toggle()">
                                                <i class="fa fa-calendar" style="cursor: pointer;"></i>
                                            </div>
                                        </div>
                                    </div>
                                </fieldset>
                            </div>
                            <div class="col-md-6 d-flex flex-column align-items-center">
                                <fieldset class="form-group d-flex flex-column">
                                    <span>Hasta</span>

                                    <div class="d-flex">
                                        <div class="d-flex flex-row-reverse align-items-center">
                                            <input class="form-control input-date-picker" placeholder="dd-mm-aaaa"
                                                name="dt" [(ngModel)]="toDate" (ngModelChange)="onChange()"
                                                ngbDatepicker [minDate]="fromDate ?? minDate" [maxDate]="maxDate"
                                                [markDisabled]="isDisabled" #dt="ngbDatepicker">
                                            <button *ngIf="toDate" type="button" class="clear-btn"
                                                (click)="clearInput('toDate')" aria-label="Limpiar" container="body"
                                                data-toggle="tooltip" placement="top" ngbTooltip="Limpiar selección">
                                                &times;
                                            </button>
                                        </div>
                                        <div class="input-group-append input-date-picker-calendar">
                                            <div class="input-group-text" (click)="dt.toggle()">
                                                <i class="fa fa-calendar" style="cursor: pointer;"></i>
                                            </div>
                                        </div>
                                    </div>
                                </fieldset>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>